import { useEffect, useMemo } from 'react';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useSetOnboardingState } from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState.ts';
import { NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

import { NTH_USER_ONBOARDING_ACTIONS_DATA } from '../nth-user-home-onboarding/cards/NthUserCards.tsx';
import type { GettingStartedCardType } from '../PersonalizedTemplatesV2Types.ts';

export const useNthUserActions = (
	dismissedCardIds: Set<string>,
): {
	areAllActionsDismissed: boolean;
	actionCardsToDisplay: GettingStartedCardType[];
} => {
	const { isRovoLLMEnabled } = useSessionData();

	const { setOnboardingState } = useSetOnboardingState();

	const actionCardsToDisplay = useMemo(() => {
		const isCardDismissed = (cardId: string) => dismissedCardIds.has(cardId);
		const shouldShowCard = (cardId: string) => {
			if (isCardDismissed(cardId)) return false;
			if (cardId === 'meetAITeammate') return isRovoLLMEnabled;
			if (cardId === 'followPeopleAndSpaces') return !isRovoLLMEnabled;
			return true;
		};
		return NTH_USER_ONBOARDING_ACTIONS_DATA.filter((card) => shouldShowCard(card.id));
	}, [dismissedCardIds, isRovoLLMEnabled]);

	useEffect(() => {
		if (actionCardsToDisplay.length === 0) {
			setOnboardingState({
				key: NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS.areAllActionsDismissed,
				value: 'true',
			});
		}
	}, [actionCardsToDisplay, setOnboardingState]);

	return {
		areAllActionsDismissed: actionCardsToDisplay.length === 0,
		actionCardsToDisplay,
	};
};
